module.exports = "/images/id-card.svg?353391bf7ec7da49b6fba9d48512185b";


//////////////////
// WEBPACK FOOTER
// ./resources/images/icons/id-card.svg
// module id = oy+o
// module chunks = 0 1